// auth.js
// -----------------------------------------------------------
// Authentification marchand — VERSION STABLE (dashboard safe)
// -----------------------------------------------------------

// Enregistrer les infos du marchand après login
export function setMerchantAuth(token, merchant) {
  localStorage.setItem("merchant_token", token);
  localStorage.setItem("merchant_id", merchant._id || merchant.id);
  localStorage.setItem("merchant_email", merchant.email);
  localStorage.setItem("merchant_name", merchant.name || "");
}

// Supprimer les infos du marchand (logout)
export function clearMerchantAuth() {
  localStorage.removeItem("merchant_token");
  localStorage.removeItem("merchant_id");
  localStorage.removeItem("merchant_email");
  localStorage.removeItem("merchant_name");
}

// Récupérer token (SANS expiration frontend)
export function getToken() {
  return localStorage.getItem("merchant_token");
}

// Vérifier si marchand connecté
export function isMerchantAuthenticated() {
  return !!localStorage.getItem("merchant_token");
}

// Récupérer l’ID du marchand
export function getMerchantId() {
  return localStorage.getItem("merchant_id");
}

// Récupérer l’email du marchand
export function getMerchantEmail() {
  return localStorage.getItem("merchant_email");
}

// (optionnel)
export function getMerchantName() {
  return localStorage.getItem("merchant_name");
}